import React, { useState } from 'react';
import { activateProject } from '../../../services/projectService';

import Button from '../../themed/button';
import Conditional from '../../common/conditional';
import Confirm from '../../themed/confirm';

import { ActivateProjectModel } from '../../../utils/models';
import { getErrorMessage } from '../../../utils/utilities';

import useProgress from '../../../hooks/useProgress';

import toastService from '../../../services/toastService';
import classNames from './style.module.scss';

interface RequestSupervisorUpdateProps {
	projectId: string;
	currentSupervisorName: string;
}

const RequestSupervisorUpdate: React.FC<RequestSupervisorUpdateProps> = ({
	currentSupervisorName,
	projectId,
}) => {
	const [showConfirmDialog, setShowConfirmDialogue] = useState(false);

	const progress = useProgress();

	const handleToggle = (): void => {
		setShowConfirmDialogue(!showConfirmDialog);
	};

	const requestReassignment = async () => {
		const apiData: ActivateProjectModel = {
			isActive: true,
			comment: 'Supervisor Update Requested',
			rejectReason: 'supervisorName',
			oldValue: currentSupervisorName,
		};

		await activateProject(projectId, apiData, progress.onProgress);
		window.location.reload();
	};

	const handleReassignmentRequest = (): void => {
		toastService.promise(requestReassignment(), {
			loading: 'Requesting Re-assignment',
			success: `Request Submitted Successfully!`,
			error: getErrorMessage,
		});
	};

	return (
		<React.Fragment>
			<div className="divider my-4"></div>

			<Conditional isVisible={showConfirmDialog}>
				<div className="p-3 bg-white border">
					<Confirm
						title="Confirm Action"
						message="Are you sure you want to request supervisor reassignment?"
						onCancel={handleToggle}
						onConfirm={handleReassignmentRequest}
					/>
				</div>
			</Conditional>

			<Conditional isVisible={!showConfirmDialog}>
				<div className="d-flex justify-content-end">
					<div className={classNames.requestSupervisorUpdate}>
						<div className="p-2 bg-light border">
							<Button
								icon="person-bounding-box"
								label="Request Supervisor Re-assignment"
								onClick={handleToggle}
								style={{ backgroundColor: '#c3781f', marginTop: 0 }}
							/>
						</div>
					</div>
				</div>
			</Conditional>
		</React.Fragment>
	);
};

export default RequestSupervisorUpdate;
